import { render } from "./AssignmentPriceGroup.vue?vue&type=template&id=077545c7&ts=true"
import script from "./AssignmentPriceGroup.vue?vue&type=script&lang=ts"
export * from "./AssignmentPriceGroup.vue?vue&type=script&lang=ts"

import "./AssignmentPriceGroup.vue?vue&type=style&index=0&id=077545c7&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__